import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from 'config';

export interface orderType {
  current_page: number;
  data: any[];
  from: number;
  last_page: number;
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: string;
  to: number;
  total: number;
}

// Define a service using a base URL and expected endpoints
export const commonApi = createApi({
  reducerPath: 'commonApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem('token');

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.query<any, any>({
      query: (body) => ({
        url: '/login',
        method: 'POST',
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        localStorage.setItem('token', data?.token ?? null);
        localStorage.setItem('info', JSON.stringify(data?.user ?? {}));
      },
    }),
    getCategories: builder.query<any, void>({
      query: () => ({
        url: '/orderType',
        method: 'GET',
      }),
    }),

    getIngredient: builder.query<
      any,
      { typeId: number; _start: number; _end: number }
    >({
      query: (args) => ({
        url: '/ingredient',
        method: 'GET',
        params: args,
      }),
    }),

    getOrders: builder.query<
      any,
      { pageSize: number; _start: number; _end: number }
    >({
      query: (args) => ({
        url: '/personalOrder',
        method: 'GET',
        params: args,
      }),
    }),
    editOrder: builder.mutation<any, any>({
      query: (body) => ({
        url: `/order/${body?.id}`,
        method: 'PATCH',
        body,
      }),
    }),
    deleteOrder: builder.mutation<any, any>({
      query: (id) => ({
        url: `/order/${id}`,
        method: 'DELETE',
      }),
    }),
    getNotifications: builder.query<any, { page: number }>({
      query: (args) => ({
        url: '/notifications',
        method: 'GET',
        params: { page: args?.page ?? 1 },
      }),
    }),

    getBills: builder.query<
      any,
      {
        pageSize: number;
        _start: number;
        _end: number;
      }
    >({
      query: (args) => ({
        url: `personalBill`,
        method: 'GET',
        params: args,
      }),
    }),

    editPwd: builder.mutation<
      any,
      {
        current_password: string | number;
        password: string | number;
        password_confirmation: string | number;
      }
    >({
      query: (body) => ({
        url: `/edit_password`,
        method: 'POST',
        body,
      }),
    }),

    //submitOrder
    submitOrder: builder.mutation<any, any>({
      query: (body) => ({
        url: `/order`,
        method: 'POST',
        body,
      }),
    }),

    getOrder: builder.query<any, { id: number }>({
      query: (args) => ({
        url: `/order/${args?.id}`,
        method: 'GET',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyLoginQuery,
  useGetCategoriesQuery,
  useGetIngredientQuery,
  useGetOrdersQuery,
  useLazyGetOrdersQuery,
  useEditOrderMutation,
  useDeleteOrderMutation,
  useLazyGetNotificationsQuery,
  useGetBillsQuery,
  useEditPwdMutation,
  useSubmitOrderMutation,
  useGetOrderQuery,
} = commonApi;
